var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "company_info" },
    [
      _c(
        "el-form",
        { attrs: { model: _vm.cmpForm, "label-width": "120px" } },
        [
          _c("div", { staticClass: "accountInfo_header_cla" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("tenant.integrationAccount")) +
                "\n    "
            )
          ]),
          _vm._v(" "),
          _vm._l(_vm.companyDetailsInfo.integrationUser, function(item) {
            return [
              _c(
                "el-row",
                { key: item.id },
                [
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "50%" },
                      attrs: { label: _vm.$t("login.account") }
                    },
                    [
                      _c("el-input", {
                        attrs: { disabled: true },
                        model: {
                          value: item.username,
                          callback: function($$v) {
                            _vm.$set(item, "username", $$v)
                          },
                          expression: "item.username"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "50%" },
                      attrs: { label: _vm.$t("login.password") }
                    },
                    [
                      _c(
                        "el-input",
                        {
                          attrs: {
                            value: "*******",
                            type: "password",
                            disabled: true
                          }
                        },
                        [
                          _vm.hasPhoneAndEmail()
                            ? _c(
                                "template",
                                { slot: "append" },
                                [
                                  _c("el-button", {
                                    attrs: {
                                      type: "primary",
                                      icon: "el-icon-edit"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.showUpdatePwd(item)
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          }),
          _vm._v(" "),
          _c("el-divider"),
          _vm._v(" "),
          _c("div", { staticClass: "companyContactInfo_cla" }, [
            _vm._v(
              "\n      " +
                _vm._s(this.$t("company.companyContactInfo")) +
                "\n    "
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "contact-panel-cla flex-display-cla" },
            [
              _c(
                "el-form-item",
                {
                  staticClass:
                    "form-item-cla flex-item-cla contact-cla formatted-name-cla",
                  staticStyle: { width: "50%" },
                  attrs: { label: this.$t("company.Contact"), prop: "name" }
                },
                [
                  _c("el-input", {
                    staticClass: "contact_input",
                    attrs: {
                      placeholder: this.$t("user.inputName"),
                      disabled: true
                    },
                    model: {
                      value: _vm.companyDetailsInfo.formattedName,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.companyDetailsInfo,
                          "formattedName",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "companyDetailsInfo.formattedName"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  staticClass: "form-item-cla flex-item-cla contact-cla",
                  staticStyle: { width: "50%" },
                  attrs: {
                    label: this.$t("company.country"),
                    prop: "countryCode"
                  }
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        filterable: "",
                        placeholder: "",
                        disabled: true
                      },
                      on: { change: _vm.changeCountry },
                      model: {
                        value: _vm.companyDetailsInfo.countryCode,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.companyDetailsInfo,
                            "countryCode",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "companyDetailsInfo.countryCode"
                      }
                    },
                    _vm._l(_vm.contryCode, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.key, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "contact-panel-cla" }, [
            _c(
              "div",
              { staticClass: "flex-display-cla" },
              [
                _c(
                  "el-form-item",
                  {
                    staticClass: "form-item-cla flex-item-cla",
                    staticStyle: { width: "50%" },
                    attrs: { label: this.$t("company.phone"), prop: "phone" }
                  },
                  [
                    _c(
                      "el-input",
                      {
                        attrs: { disabled: true },
                        model: {
                          value: _vm.phone,
                          callback: function($$v) {
                            _vm.phone = $$v
                          },
                          expression: "phone"
                        }
                      },
                      [
                        _c("template", { slot: "prepend" }, [
                          _vm._v("+" + _vm._s(_vm.companyDetailsInfo.prefix))
                        ])
                      ],
                      2
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticClass: "form-item-cla flex-item-cla",
                    staticStyle: { width: "50%" },
                    attrs: { label: this.$t("company.email"), prop: "email" }
                  },
                  [
                    _c("el-input", {
                      attrs: { disabled: true },
                      model: {
                        value: _vm.email,
                        callback: function($$v) {
                          _vm.email = typeof $$v === "string" ? $$v.trim() : $$v
                        },
                        expression: "email"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ])
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            title: _vm.$t("account.modifyPwd"),
            width: "40%"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.handleClose
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "codeForm",
              attrs: {
                model: _vm.interForm,
                "label-width": "140px",
                rules: _vm.rules
              }
            },
            [
              _vm.step === "first"
                ? [
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 16 } },
                          [
                            _vm.isEmail
                              ? [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: { label: this.$t("company.email") }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: { disabled: true },
                                        model: {
                                          value: _vm.interForm.email,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.interForm,
                                              "email",
                                              $$v
                                            )
                                          },
                                          expression: "interForm.email"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              : _c(
                                  "tempalte",
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: this.$t("company.phone")
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: { disabled: true },
                                          model: {
                                            value: _vm.interForm.phone,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.interForm,
                                                "phone",
                                                $$v
                                              )
                                            },
                                            expression: "interForm.phone"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _vm.isChange
                          ? _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "primary",
                                      disabled: !_vm.isChange
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.changeWay(_vm.isEmail)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("developer.changeWay"))
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 16 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: this.$t("center.code"),
                                  prop: "code"
                                }
                              },
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "" },
                                  model: {
                                    value: _vm.interForm.code,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.interForm,
                                        "code",
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                      )
                                    },
                                    expression: "interForm.code"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c("timing", {
                              ref: "timing",
                              attrs: { status: true, isShow: true },
                              on: { toGetCode: _vm.getEmailCode }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.step === "second"
                ? [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("user.password"),
                          prop: "password"
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            autocomplete: "off",
                            type: "password",
                            placeholder: this.$t("user.inputPwd")
                          },
                          model: {
                            value: _vm.interForm.password,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.interForm,
                                "password",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "interForm.password"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("user.confirmedPwd"),
                          prop: "secondPwd"
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            autocomplete: "off",
                            type: "password",
                            placeholder: this.$t("user.input2ndPwd")
                          },
                          model: {
                            value: _vm.interForm.secondPwd,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.interForm,
                                "secondPwd",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "interForm.secondPwd"
                          }
                        })
                      ],
                      1
                    )
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.step === "third"
                ? [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          width: "100%",
                          display: "flex",
                          "flex-direction": "column",
                          "justify-content": "center",
                          "align-items": "center"
                        }
                      },
                      [
                        _c("i", {
                          staticClass: "el-icon-circle-check",
                          staticStyle: {
                            "font-size": "60px",
                            display: "block",
                            color: "#4db22f"
                          }
                        }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("operationMsg.updateSuc")))
                        ])
                      ]
                    )
                  ]
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v(_vm._s(_vm.$t("common.cancel")))
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.sumbitUpdate } },
                [_vm._v(_vm._s(_vm.$t("common.confirm")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-35e810b5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35e810b5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/tenantManager/companyInfo/detailPage/companyInfomation.vue
// module id = null
// module chunks = 